<template>
  <UniversalSelect
      v-model="localModel"
      :mode="mode"
      :searchable="searchable"
      :options="options"
      :default-image="defaultImage"
      :label="label"
      placeholder="Не выбрано"
      @onChange="emit('change', $event)"
  />
</template>

<script setup>
import { ref, computed, defineOptions } from "vue"
import UniversalSelect from "@/components/select_universal/Index"
import { OPTIONS } from "./options"

defineOptions({
  name: "WishlistCurrency"
})

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: null
  },
  mode: {
    type: String,
    default: "tags"
  },
  searchable: {
    type: Boolean,
    default: true
  },
  defaultImage: {
    type: String,
    default: "/assets/static/user/no_image.jpg"
  },
  label: {
    type: String,
    default: "Валюта"
  },
})

const emit = defineEmits(['update:modelValue', 'change'])

const localModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const options = ref(OPTIONS)
</script>
